import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { unwrapList } from '../lib/unwrap'

export interface Notification {
  id: string
  title: string
  message: string
  channel: string
  read: boolean
  created_at: string
}

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get('/notifications').then((r) => unwrapList<Notification>(r.data)),
  })
}

export function useMarkNotificationRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.post(`/notifications/${id}/read`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  })
}

export function useDeleteNotification() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/notifications/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  })
}

export interface SendNotificationPayload {
  title: string
  message: string
  severity: 'info' | 'warning' | 'critical'
  target: 'all' | 'specific'
  user_ids?: string[]
}

export interface SendNotificationResult {
  notification_id: string
  recipients: number
  push_sent: number
}

export function useSendNotification() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: SendNotificationPayload) =>
      api.post<SendNotificationResult>('/notifications/send', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  })
}
